'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './MultiOrderTitle.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface MultiOrderTitleProps {
	readonly orderIndex: number
}

export function MultiOrderTitle({ orderIndex }: MultiOrderTitleProps) {
	const { t } = useLabels()
	return (
		<h2 className={`${text.titleL} ${styles.headline}`}>
			<ClientLabel
				placeholderValues={{
					1: orderIndex + 1,
				}}
			>
				{t('myPurchases.online.multiOrder.parcelNumber.title')}
			</ClientLabel>
		</h2>
	)
}
